import * as React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
export var BusIcon =
/*#__PURE__*/
// eslint-disable-next-line react/forbid-elements
_jsx("svg", {
  width: "16",
  height: "16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  children: /*#__PURE__*/_jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 3.472c0-.31.073-.62.29-.842C2.851 2.05 4.374 1 8 1s5.148 1.051 5.71 1.63c.217.222.29.532.29.842V12a1 1 0 0 1-1 1v.5a1 1 0 0 1-1 1h-1a1 1 0 0 1-1-1V13H6v.5a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V13a1 1 0 0 1-1-1V3.472ZM5 11.5a1 1 0 1 0 0-2 1 1 0 0 0 0 2Zm6 0a1 1 0 1 0 0-2 1 1 0 0 0 0 2ZM12 4v3H4V4h8Z",
    fill: "currentColor"
  })
});